import { render, staticRenderFns } from "./Tukang_Shop.vue?vue&type=template&id=711bcaf0&scoped=true&"
import script from "./Tukang_Shop.vue?vue&type=script&lang=js&"
export * from "./Tukang_Shop.vue?vue&type=script&lang=js&"
import style0 from "./Tukang_Shop.vue?vue&type=style&index=0&id=711bcaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711bcaf0",
  null
  
)

export default component.exports